<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #768192;
    border-color: none; 
    border : none;
    background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center">
      Data Peserta Sertifikasi RPL
    </CCardHeader>
    <div class="card-body">
        <div class="row">
            <div class="col-sm-4 col-xl-4">
                <label for="exampleFormControlSelect1" class="font-weight-bold">Nama RPL</label>
                <multiselect  
                  v-model="valuePencarianRPL"
                  label="namaSertifikasi"
                  :options="optionPencarianRPL" 
                  :searchable="true" 
                  :close-on-select="true" 
                  :show-labels="false" 
                  placeholder="Pick a value"
                ></multiselect> </div>
        </div>
        <br>
      </div>
    <CCardBody>
      <!-- filter -->
      <!-- end filter -->
      <ul
        class="nav nav-tabs bg-active border-0 border-bottom-0"
        id="myTab"
        role="tablist"
      >
        <li class="nav-item" >
          <div
            :class="tab_selected.aria_selected_dinilai ? 'nav-link p-3 px-4 font-weight-bold text-white active' : 'nav-link p-3 px-4 font-weight-bold text-white'"
            id="home-tab"
            data-toggle="tab"
            href="#home"
            style="cursor: pointer"
            role="tab"
            aria-controls="home"
            @click="tabchange('dinilai')"
            :aria-selected="tab_selected.aria_selected_dinilai">
            Dinilai
            <span class="badge badge-info text-white">{{ badges.totalDinilai }}</span>
          </div>
        </li>
        <li class="nav-item">
          <div
            :class="tab_selected.aria_selected_belum_dinilai ? 'nav-link p-3 px-4 font-weight-bold text-white active' : 'nav-link p-3 px-4 font-weight-bold text-white'"
            id="profile"
            data-toggle="tab"
            href="#profile"
            style="cursor: pointer"
            role="tab"
            aria-controls="profile"
            @click="tabchange('belum_dinilai')"
            :aria-selected="tab_selected.aria_selected_belum_dinilai">
            Belum Dinilai
            <span class="badge badge-warning text-white">{{
              badges.totalBelumDinilai
            }}</span>
          </div>
        </li>
        <li class="nav-item">
          <div
            :class="tab_selected.aria_selected_belum_lunas ? 'nav-link p-3 px-4 font-weight-bold text-white active' : 'nav-link p-3 px-4 font-weight-bold text-white'"
            id="belum-lunas"
            data-toggle="tab"
            href="#belum-lunas"
            style="cursor: pointer"
            role="tab"
            aria-controls="home"
            @click="tabchange('belum_lunas')"
            :aria-selected="tab_selected.aria_selected_belum_lunas">
            Belum Lunas
            <span class="badge badge-success text-white">0</span>
          </div>
        </li>
        <li class="nav-item">
          <div
            :class="tab_selected.aria_selected_verify ? 'nav-link p-3 px-4 font-weight-bold text-white active' : 'nav-link p-3 px-4 font-weight-bold text-white'"
            id="profile"
            data-toggle="tab"
            href="#profile"
            style="cursor: pointer"
            role="tab"
            aria-controls="profile"
            @click="tabchange('verify')"
            :aria-selected="tab_selected.aria_selected_verify">
            Verify
            <span class="badge badge-danger text-white">{{
              badges.totalVerify
            }}</span>
          </div>
        </li>
      </ul>
      <CRow>
        <CCol sm="12" lg="12" md="12">
          <CDataTable
            style="widht: 100% !important"
            :items="items"
            :fields="get_data_status.status_biaya == 'lunas' ? fields : fieldsLainya"
            hover
            sorter>
            <template #no="{ index }">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>

            <template #noAnggota="{ item }">              
              <td class="py-2">{{ item.noAnggota ? item.noAnggota : "-" }}</td>
            </template>
            <template #tipe="{ item }">              
              <td class="py-2">{{ item.tipe ? item.tipe : "-" }}</td>
            </template>
            <template #email="{ item }">              
              <td class="py-2">{{ item.email ? item.email : "-" }}</td>
            </template>

            <template #jumlah_mata_ujian="{item}">
              <td class="py-2">{{ item.jumlah_mata_ujian }}</td>
            </template>
           
            <template #persyaratanDokumen="{ item }">
              <td class="py-2">
                {{ item.persyaratanDokumen ? item.persyaratanDokumen : "-" }}
              </td>
            </template>

            <template #nama_lengkap="{ item, index }">
              <td
                class="py-2 text-info"
                style="cursor: pointer"
                @click="detailUser(item, index)">
                {{ item.nama_lengkap ? item.nama_lengkap : "-" }}
              </td>
            </template>

            <template #tgl_daftar="{ item }">
              {{ item }}
              <td class="py-2">
                {{ item.tgl_daftar ? item.tgl_daftar : "-" }}
              </td>
            </template>

            <template #tanggal_daftar="{ item }">
              <td class="py-2">
                {{ item.tanggal_daftar ? item.tanggal_daftar : "-" }}
              </td>
            </template>

            <template #aksi="{ item }">
              <td class="py-2 text-center">
        
                <router-link :to="'/sertifikasi-new/data-peserta-sertifikasi-detail/' +item.idSertifikasiPeserta">
                
                  <CButton
                    v-c-tooltip="'Lihat Mata Uji Peserta'"
                    color="success"
                    class="btn-sm mr-2"
                    square>
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </CButton> 
                </router-link>

                <router-link
                  :to="'/sertifikasi-new/data-peserta/data-dokumen/' + item.idSertifikasiPeserta">
                  <CButton
                    v-c-tooltip="'Lihat Dokumen Peserta'"
                    color="warning"
                    class="btn-sm text-white" square>
                    <i class="fa fa-file" aria-hidden="true"></i>
                  </CButton>
                </router-link>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float: right"
            :active-page.sync="currentPageDataPesertaSertifikasi"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
    </CCardBody>
  </CCard>
</template>
<script>
import DataPesertaService from "@/services/sertifikasi/data-peserta.service.new.js";

import { AlertUtils } from "@/mixins/AlertUtils";
import { PaginationDataPesertaSertifikasi } from "@/mixins/paginationType/PaginationDataPesertaSertifikasi";
import { exportUtils } from '@/mixins/exportUtils';
import { KategoriAnggota } from "@/mixins/master/KategoriAnggota";

import FilterSertifikasi from "@/components/sertifikasi/datapeserta/FilterSertifikasi";
import ModalDetailPesertaSertifikasi from "@/components/sertifikasi/datapeserta/ModalDetailPesertaSertifikasi";
import ModalPengajuanPembatalanSertifikasi from "@/components/sertifikasi/datapeserta/ModalPengajuanPembatalanSertifikasi";
import SertifikasiService from "../../../services/sertifikasi/master-sertifikasi.service.new";

const fields = [
  {
    key: "no",
    sorter: true,
    filter: false,
  },
  {
    key: "noAnggota",
    label: "No Anggota",
    sorter: true,
    filter: false,
  },
  {
    key: "namaSertifikasi",
    label: "namaSertifikasi",
    sorter: true,
    filter: false,
  },
  {
    key: "tanggalMulai",
    label: "tanggalAkhir",
    sorter: true,
    filter: false,
  },
  {
    key: "email",
    label: "Email",
    sorter: true,
    filter: false,
  },
  {
    key: "jumlahMataUjiWaiver",
    label: "Jumlah Mata Uji Waiver",
    sorter: true,
    filter: false,
  }, 
  {
    key: "aksi",
    _style: "width:20%; text-align: center",
    sorter: false,
    filter: false,
  },
];

const fieldsLainya = [
  {
    key: "no",
    sorter: true,
    filter: false,
  },
  {
    key: "noAnggota",
    label: "No Anggota",
    sorter: true,
    filter: false,
  },
  {
    key: "tipe",
    label: "Nama RPL",
    sorter: true,
    filter: false,
  },
  {
    key: "nama",
    label: "Nama",
    sorter: true,
    filter: false,
  },
  {
    key: "email",
    label: "Email",
    sorter: true,
    filter: false,
  },
  {
    key: "aksi",
    _style: "width:20%; text-align: center",
    sorter: false,
    filter: false,
  },
];

export default {
  mixins: [
    AlertUtils, 
    PaginationDataPesertaSertifikasi, 
    KategoriAnggota,
    exportUtils
  ],

  components: {
    FilterSertifikasi,
    ModalDetailPesertaSertifikasi,
    ModalPengajuanPembatalanSertifikasi,
  },

  watch : {
    'valuePencarianRPL' : function (val) {
      this.formFilter.id_sertifikasi = val.idSertifikasi
      console.log(this.formFilter)
      this.getData(0, 10, "default", this.formFilter.id_sertifikasi, this.formFilter.status_pembayaran, this.formFilter.periode);
    }
  },

  data() {
    return {
      tab_selected: {
        aria_selected_dinilai: true,
        aria_selected_belum_dinilai: false,
        aria_selected_verify: false,
        aria_selected_belum_lunas: false,
      },
      badges: {
        totalDinilai: 0,
        totalBelumDinilai: 0,
        totalApproved : 0,
        totalVerify: 0
      },
      get_data_status: {
        status_biaya: "dinilai",
      },
      valuePencarianRPL: {},
      modalDetailPembatalan: false,
      modalTitleDetailPembatalan: "Detail Pembatalan",
      formDataPembatalan: {},
      modalTitle: "Detail User",
      items: [],
      sertifikasi: "",
      kategori_anggota: "",
      formFilter: {
        id_sertifikasi: "",
        status_pembayaran: "",
        periode: ""
      },
      dataSertifikasi: [],
      details: [],
      fieldsLainya,
      fields,
      searchSertifikasi: "",
      status: false,
      myModal: false,
      modalDetail: false,
      horizontal: { label: "col-3", input: "col-9" },
      indexed: 0,
      collapseDuration: 0,
      content: [],
      loading: true,
      optionPencarianRPL: [
        {
          idSertifikasi : '',
          namaSertifikasi: 'Semua'
        }
      ]
    };
  },

  mounted() {
    this.getData(0, 10, "default", this.formFilter.id_sertifikasi, this.formFilter.status_pembayaran, this.formFilter.periode);
    this.getListSertifikasi(null,null,null,null)
  },  

  methods: {
    syncSearch(value) {
      // comment console console.log(value)
      this.searchDataPesertaSertifikasi = value;
    },

    tabchange(value) {
      switch (value) {
        case "dinilai":
          this.tab_selected.aria_selected_dinilai = true;
          this.tab_selected.aria_selected_belum_dinilai = false;
          this.tab_selected.aria_selected_batal = false;
          this.tab_selected.aria_selected_false = true;
          this.formFilter.status_pembayaran = "dinilai";
          this.getData(
            0,
            10,
            "default",
            this.formFilter.id_sertifikasi,
            this.formFilter.status_pembayaran,
            this.formFilter.periode
          );
          // this.getCountLunas();
          // this.getCountBelumLunas();
          // this.getCountLainnya();
          break;
        case "belum_dinilai":
          this.tab_selected.aria_selected_dinilai = false;
          this.tab_selected.aria_selected_belum_dinilai = true;
          this.tab_selected.aria_selected_belum_lunas = false;
          this.tab_selected.aria_selected_verify = false;
          this.formFilter.status_pembayaran = "belum_dinilai";
          // this.getCountLunas();
          // this.getCountBelumLunas();
          // this.getCountLainnya();

          this.getData(
            0,
            10,
            "default",
            this.formFilter.id_sertifikasi,
            this.formFilter.status_pembayaran,
            this.formFilter.periode
          );
          break;
        case "belum_lunas":
          this.tab_selected.aria_selected_dinilai = false;
          this.tab_selected.aria_selected_belum_dinilai = false;
          this.tab_selected.aria_selected_belum_lunas = true;
          this.tab_selected.aria_selected_verify = false;
          this.formFilter.status_pembayaran = "belum_lunas";
          // this.getCountLunas();
          // this.getCountBelumLunas();
          // this.getCountLainnya();

          this.getData(
            0,
            10,
            "default",
            this.formFilter.id_sertifikasi,
            this.formFilter.status_pembayaran,
            this.formFilter.periode
          );
          break;
        case "verify":
          this.tab_selected.aria_selected_dinilai = false;
          this.tab_selected.aria_selected_belum_dinilai = false;
          this.tab_selected.aria_selected_belum_lunas = false;
          this.tab_selected.aria_selected_verify = true;
          this.formFilter.status_pembayaran = "verify";
          // this.getCountLunas();
          // this.getCountBelumLunas();
          // this.getCountLainnya();

          this.getData(
            0,
            10,
            "default",
            this.formFilter.id_sertifikasi,
            this.formFilter.status_pembayaran,
            this.formFilter.periode
          );
          break;
        default:
          break;
      }
    },

    getCountLunas() {
      DataPesertaService.getDataPeserta(
        0,
        10,
        "default",
        this.formFilter.id_sertifikasi,
        'lunas',
        this.formFilter.periode
      )
        .then((response) => {
          this.badges.totalDinilai = response.data.data.totalElements;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    getCountBelumLunas() {
      DataPesertaService.getDataPeserta(
        0,
        1,
        "default",
        this.formFilter.id_sertifikasi,
        'belum_lunas',
        this.formFilter.periode
      )
        .then((response) => {
          this.badges.totaldinilai = response.data.data.totalElements;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    getCountLainnya() {
      DataPesertaService.getDataPeserta(
        0,
        10,
        "default",
        this.formFilter.id_sertifikasi,
        'batal',
        this.formFilter.periode
      )
        .then((response) => {
          this.badges.totalLainnya = response.data.data.totalElements;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    exportDataPeserta(value) {
      // if(this.form)
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      DataPesertaService.exportDataPeserta(
        value.periode,
        value.id_sertifikasi,
        value.status_pembayaran
      ).then(response => {
        loader.hide();
        this.exportDataCorupt(response.data, 'DataPesertaSertifikasi');
        this.alertExportSuccess();
      }).catch(error => {
        // comment console console.log(error)
        this.alertExportFailed();
        loader.hide()
      })
    },

    filterData(formFilter) {
      this.formFilter = formFilter;
      this.getData(
        0,
        10,
        "default",
        this.formFilter.id_sertifikasi,
        this.formFilter.status_pembayaran,
        this.formFilter.periode
      );
      this.getCountLunas();
      this.getCountBelumLunas();
      this.getCountLainnya();
    },

    pilihStatusPembayaran(e) {
      this.modelStatusPembayaran = e.target.value;
      this.modelIdSertifikasi = "default";
      this.getData(
        "0",
        this.pageSize,
        this.searchSertifikasi,
        "default",
        this.modelStatusPembayaran
      );
    },

    pageChange() {
      this.getData(currentPage);
    },

    getData(
      currentPage,
      pageSize,
      filter,
      id_sertifikasi,
      status_pembayaran,
      periode
    ) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });

      var vm = this;
      DataPesertaService.getDataPesertaRPL(
        currentPage,
        pageSize,
        filter,
        id_sertifikasi,
        status_pembayaran,
        periode
      )
        .then((response) => {
          console.log(response)
          loader.hide();          
          vm.items = response.data.content;
          vm.pagination.totalPages = response.data.totalPages;
          vm.currentPageDataPesertaSertifikasi =
            response.data.pageable.pageNumber + 1;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeSertifikasi(value) {
      this.modelStatusPembayaran = "default";
      this.modalDetailPembatalan = false;
      this.idSertifikasi = value.idSertifikasi;
      this.getData(
        "0",
        this.pageSize,
        "default",
        value.idSertifikasi,
        "default"
      );
    },

    changePageSizeDataPesertaSertifikasi(e) {
      this.changePageSize(e);
    },

    closeModalDetail(e) {
      if(e === false) {
        this.modalDetail = false;
      }
    },

    closeModalPembatalan(e) {
      if(e === false) {
        this.modalDetailPembatalan = false;
      }
    },
    
    getListSertifikasi() {
      SertifikasiService.getSertifikasi(null,null,null,null)
        .then((res) => {
          console.log(res.data.content)
          var vm = this;
          res.data.content.forEach(element => {
            if(element.tipeSertifikasi == 2) {
              vm.optionPencarianRPL.push(element);
            }
          });
          console.log(this.optionPencarianRPL)
        })
        .catch((err) => {
          console.log(err);
        })
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
  button:disabled {
    cursor: no-drop;
  }
</style>